import { ButtonHTMLAttributes, forwardRef } from 'react';

import { cn } from '../utils/cn';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  loading?: boolean;
}

// Wygląd 1:1 z kanonicznymi klasami Aurora `.btn` (aurora.css) — bez lokalnych
// metryk i fallbackowych hexów, żeby pakiet nie mógł dryfować względem DS
// (wysokość z --ids-control-h reaguje na data-density, :active daje scale(.97),
// focus-visible obsługuje globalny outline tokenowy). API propsów bez zmian;
// `outline` mapuje się na `.btn--secondary` (najbliższy kanoniczny wariant
// obrysowy), `md` to domyślna wysokość bez modyfikatora.
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'primary', size = 'md', loading, disabled, children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          'btn',
          {
            'btn--primary': variant === 'primary',
            'btn--secondary': variant === 'secondary' || variant === 'outline',
            'btn--ghost': variant === 'ghost',
            'btn--danger': variant === 'danger',
            'btn--sm': size === 'sm',
            'btn--lg': size === 'lg',
          },
          className
        )}
        disabled={disabled || loading}
        {...props}
      >
        {loading && <span className="spinner" aria-hidden="true" />}
        {children}
      </button>
    );
  }
);

Button.displayName = 'Button';
